<template>
    <div class="w-full">
     <slot></slot>
    </div>
</template>

<script>
    export default {
        name:'grid-component'
    }
</script>

<style lang="scss" scoped>

</style>
